import React from "react";

export function PopupFonContainer(props: { onClick?: () => void }) {
	return (
		<div onClick={props.onClick} className={"mainSearchFonContainer"}></div>
	);
}
